export namespace utils {
  export namespace json {
    export function SafeParse(stringObj: string): any {
      try {
        return JSON.parse(stringObj);
      } catch (_) {
        return null;
      }
    }
  }
}
